import "@wehome/form-builder/styles.css"
import "@wehome/roster-planner/styles.css"
import AppRoutes from "../AppRoutes"
import { injectCustomCss } from "../utils/injectCustomCss"
import React, { useEffect, useMemo } from "react"
import * as MUI from "@mui/material"
import * as ReactHookForm from "react-hook-form"
import * as Zod from "zod"
import * as ReactBootstrap from "react-bootstrap"
import { zodResolver } from "@hookform/resolvers/zod"
import axios from "axios"
import {
    computeColumns,
    extractDateOnlyFromDateTimeString,
    fileToBase64,
    formatRoleName,
    formattingValue,
    getEntityIdFromURL,
    getSlugFromURL,
    getMetricConfig,
    loadAndInjectExtension,
    toTitleCase,
    voiceiiTranslation,
    convertUTCTimeToLocalTimeString,
    convertUTCDateToLocalDateString,
    convertUTCDateTimeToLocalDateTimeString,
} from "../utils"
import { useAssetDetailExtensionV2 } from "../hooks/useAssetDetailExtensionV2"
import _ from "lodash"
import { useLocation, useNavigate } from "react-router-dom"
import {
    formatVitalReading,
    getBmiCategory,
    getBmiValue,
    getPatientHeightCentimeters,
    getPatientHeightMeters,
    isAbnormal,
} from "../utils/vitalMapping"
import { BASE_URL } from "../screens/Alerts/Alerts"
import { base_headers, base_headersMultipart } from "../screens/DynamicAssets/constant"
import * as Recharts from "recharts"
import TableViewIcon from "@mui/icons-material/TableView"
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart"
import EventIcon from "@mui/icons-material/Event"
import EastIcon from "@mui/icons-material/East"
import { useDatatableCtx } from "./Datatable/DatatableContext"
import { TimestampContext } from "./TimeDurationFilter/TimeStampProvider"
import { Tooltip as MTooltip } from "@mui/material"
import * as EnqueueSnackbar from "notistack"
import { useLocalization } from "../providers/LocalizationProvider"
import { useFormat } from "../context/FormatContext"
import { useRoutePermission } from "../context/RoutePermissionContext"
import { getCurrentLocation } from "../utils/gps"
import { GoogleMap, DirectionsRenderer, useJsApiLoader, OverlayView } from "@react-google-maps/api"
import SimpleBackdropLoader from "../screens/BackdropLoading/BackdropLoading"
import AssetFormModal from "../screens/DynamicAssetsModule/AssetFormModal"
import AssetDetailDataTable from "../screens/DynamicAssetsModule/AssetDetailDataTable"
import TimeDurationFilter from "./TimeDurationFilter/TimeDurationFIlter"
import Modal from "./Modal"
import RouteDatePicker from "../screens/DynamicAssetsModule/RouteDatePicker"
import DataTable from "../Data/TablesData/Datatable"
import flatpickr from "flatpickr"
import Flatpickr from "react-flatpickr"
import { formatVisitDate } from "./form/elements/RepeatVisitsScheduler"
import { useSelector, useDispatch } from "react-redux"
import { handleLogoutUser } from "../screens/Logout"
import { logoutUser } from "../redux/actions"
import { isRouteActiveLink, updateLanguage } from "../utils"
import { LANGUAGE_OPTIONS } from "../Data/constant"
import { selectAuthUser } from "../redux/auth/selectors"
import { setRoutingSummary } from "../redux/routingSummary/reducers"
import AppLogo from "../screens/AppLogo"
import { usePinnedSidebar } from "../context/PinnedSidebarContext"
import { selectWebsiteData } from "../redux/general/selectors"
import DynamicDetailFormModal from "../screens/DynamicAssetsModule/DynamicDetailFormModal"
import FormHistoryModal from "../screens/DynamicAssetsModule/FormHistoryModal"
import MyVisitsMap from "../screens/DynamicAssetsModule/MyVisitsMap"
import { loadtplTemplate, parseTemplate, renderTemplate } from "../utils/loadtplTemplate"
import { createTemplateEngine } from "../utils/templateEngine"
import { renderToStaticMarkup } from "react-dom/server"
import { createPortal } from "react-dom"
import { FetchHelper } from "../utils/fetchHelper"
import { showError, showInfo, showSnackbar, showSuccess, showWarning } from "../utils/snackbar"
import { FormBuilder } from "@wehome/form-builder"
import { RosterPlanner } from "@wehome/roster-planner"
import PageHeaderBar from "./PageHeaderBar"

const tplEngine = createTemplateEngine({ loader: loadtplTemplate })

window.ExtensionRuntime = {
    libraries: {
        React,
        ReactBootstrap,
        MUI,
        ReactHookForm,
        Zod,
        ZodResolver: zodResolver,
        axios,
        lodash: _,
        useLocation,
        Recharts,
        useNavigate,
        EnqueueSnackbar,
        flatpickr,
        Flatpickr,
        FormBuilder,
        RosterPlanner,
    },
    DynamicComponents: {
        DynamicModal: Modal,
        SimpleBackdropLoader,
        AssetFormModal,
        AssetDetailDataTable,
        TimeDurationFilter,
        Modal,
        RouteDatePicker,
        AppLogo,
        DynamicDetailFormModal,
        FormHistoryModal,
        MyVisitsMap,
        PageHeaderBar,
    },
    dynamicApis: {
        getEntityIdFromURL,
        getSlugFromURL,
        BASE_URL,
        base_headers,
        fileToBase64,
        computeColumns,
    },
    utils: {
        getEntityIdFromURL,
        getSlugFromURL,
        isAbnormal,
        formatVitalReading,
        computeColumns,
        extractDateOnlyFromDateTimeString,
        getCurrentLocation,
        formatVisitDate,
        formatRoleName,
        formattingValue,
        getMetricConfig,
        getPatientHeightCentimeters,
        getPatientHeightMeters,
        getBmiValue,
        getBmiCategory,
        loadtplTemplate,
        parseTemplate,
        renderTemplate,
        tplEngine,
        FetchHelper,
        toTitleCase,
        renderToStaticMarkup,
        createPortal,
        isRouteActiveLink,
        updateLanguage,
        LANGUAGE_OPTIONS,
        voiceiiTranslation,
        convertUTCTimeToLocalTimeString,
        convertUTCDateToLocalDateString,
        convertUTCDateTimeToLocalDateTimeString
    },
    hooks: {
        useLocalization,
        useFormat,
        useAssetDetailExtensionV2,
        useRoutePermission,
        usePinnedSidebar,
    },
    ReactDataTable: {
        DataTable,
    },
    baseUrl: {
        BASE_URL,
    },
    apiHeaders: {
        base_headers,
        base_headersMultipart,
    },
    icons: {
        TableViewIcon,
        StackedLineChartIcon,
        // Activity icons
        EventIcon,
        EastIcon,
    },
    customContexts: {
        TimestampContext,
        useDatatableCtx,
    },
    toolTip: {
        MTooltip,
    },
    googleMaps: {
        GoogleMap,
        DirectionsRenderer,
        useJsApiLoader,
        OverlayView,
    },
    redux: {
        useSelector,
        useDispatch,
        selectWebsiteData,
        selectAuthUser,
        setRoutingSummary,
    },
    auth: {
        handleLogoutUser,
        logoutUser,
    },
    enqueueSnackbar: {
        showSnackbar,
        showSuccess,
        showError,
        showWarning,
        showInfo,
    },
}

export default function ExtensionRuntimeProvider() {
    const { voiceiiTags } = useLocalization()

    useEffect(() => {
        tplEngine.setTranslate(voiceiiTags)
        // expose globally
        window.voiceiiTags = voiceiiTags
    }, [voiceiiTags])

    useMemo(() => {
        // Load global extensions and sidebar templates from master_v2
        const initializeExtensions = async () => {
            await loadAndInjectExtension("globalPermission.js", "globalPermission", "master_v2")

            // Preload sidebar templates from master_v2 into the template engine cache
            const baseUrl = process.env.REACT_APP_API_URL || ""
            const tplNames = [
                "collapsed-sidebar-page",
                "collapsed-sidebar-nav",
                "expanded-sidebar-page",
                "expanded-sidebar-nav",
            ]
            await Promise.all(
                tplNames.map(async (name) => {
                    try {
                        const url = `${baseUrl}static/media-files/asset/master_v2/dynamic-action/extensions/${name}.tpl?v=${Date.now()}`
                        const res = await fetch(url)
                        if (res.ok) {
                            const template = await res.text()
                            tplEngine.registerPartial(name, template)
                        }
                    } catch (err) {
                        console.warn(`[ExtensionRuntime] Failed to preload template: ${name}`, err)
                    }
                }),
            )

            // Load sidebar JS extensions from master_v2
            await loadAndInjectExtension(
                "collapsed-sidebar_build.js",
                "collapsed-sidebar",
                "master_v2",
            )
            await loadAndInjectExtension(
                "expanded-sidebar_build.js",
                "expanded-sidebar",
                "master_v2",
            )
        }
        initializeExtensions()

        // Inject CSS for extensions
        injectCustomCss()
    }, [])

    return (
        <div className="app-scope">
            <AppRoutes />
        </div>
    )
}
